export enum SearchContextKeys {
  Tickets = 'tickets',
  Incidents = 'incidents',
  Assets = 'assets',
  Findings = 'findings',
  Exceptions = 'exceptions',
  Pivot = 'pivot',
  RemediationDashboard = 'remediation',
  RiskDashboard = 'risk',
  PolicyViolation = 'policy_violation',
  ViolationTicket = 'violation_tickets',
  Alerts = 'alerts',
  AlertsNew = 'alerts_new',
  IncidentsThreats = 'incidents_threats',
  SmallTicketsTable = 'smallTicketsTable',
  Logs = 'logs',
  Domains = 'domains',
  Tenants = 'tenants',
  IdentityFindings = 'identityFindings',
  Identities = 'identities',
  Sources = 'sources',
}
